import { servicePendingTasks } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import { pendingTasks as typesPendingTasks, network } from 'types';

const useApprovePendingTask = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<null>,
        string,
        typesPendingTasks.TPendingTasks
    >({
        mutationFn: servicePendingTasks.approve,
        mutationConfig: {},
        asyncStateHandlers: arg0,
    });
};

export default useApprovePendingTask;
